import { render, staticRenderFns } from "./activity-rules.vue?vue&type=template&id=65b7d85a&scoped=true&"
import script from "./activity-rules.vue?vue&type=script&lang=js&"
export * from "./activity-rules.vue?vue&type=script&lang=js&"
import style0 from "./activity-rules.vue?vue&type=style&index=0&id=65b7d85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7d85a",
  null
  
)

export default component.exports